import React from "react"

export default function NotFound() {

    return <div id="not-found">Ovde nema ništa</div>
}